import React, { useState, useEffect } from "react";
import Button from 'antd/lib/button/button';
import TimePicker  from 'antd/lib/time-picker';
import { RESTRICTIONS_TABLE_TIME_FORMAT } from '../TimeInputsRow';
import { RangeValue } from 'rc-picker/lib/interface';
import { formatDateToTimeStr } from '../../../../../../../../utils/MiscUtils';
import styles from './TimeInputs.module.css';

const { RangePicker } = TimePicker;

type HandleRangePickerChange = (values: RangeValue<any>, formatString: [string, string]) => void;

interface ITimeInputsProps {
  isSorting?: boolean
  clickHandler: (arg0: any, arg1: any) => void
}

export const TimeInputs: React.FC<ITimeInputsProps> = (props) => {

  const { clickHandler, isSorting } = props;

  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  useEffect(() => {
    if (isSorting) {
      setStartTime(null);
      setEndTime(null);
    }
  }, [isSorting]);

  const handleValueChange: HandleRangePickerChange = (values, formatString) => {
    if (values) {
      setStartTime(values[0]);
      setEndTime(values[1]);
    }
  }

  const handleSubmit = (e: any) => {
    clickHandler(formatDateToTimeStr(startTime) as any, formatDateToTimeStr(endTime) as any);
    setStartTime(null);
    setEndTime(null);
  }

  return (
    <div className={styles.datepickerWrapper}>
      <RangePicker value={[startTime, endTime]} format={RESTRICTIONS_TABLE_TIME_FORMAT} onChange={handleValueChange} allowClear={false}/>
      <Button type='link' onClick={handleSubmit} disabled={!startTime || !endTime}>Add</Button>
    </div>
  )
}

export default TimeInputs;
